import { api, method } from '../api/apiClient';

export const saveBusinessDetails = async (payload) => {
    try {
        return await api(method.POST, `/checkout/business`, payload);
    } catch (error) {
        console.error(`Error while saving businness details ${error}`);
        throw error;
    }
};

export const saveStakeholderDetails = async (payload) => {
    try {
        return await api(method.POST, `/checkout/stakeholder`, payload);
    } catch (error) {
        console.error(`Error while saving stakeholder details ${error}`);
        throw error;
    }
};

export const saveBankDetails = async (payload) => {
    try {
        return await api(method.POST, `/checkout/account`, payload);
    } catch (error) {
        console.error(`Error while saving bank details ${error}`);
        throw error;
    }
};

export const paymentRequest = async (payload) => {
    try {
        return await api(method.POST, `/checkout/payment`, payload);
    } catch (error) {
        console.error(`Error while order payment request ${error}`);
        throw error;
    }
};

export const paymentSuccess = async (payload) => {
    try {
        return await api(method.POST, `/checkout/success`, payload);
    } catch (error) {
        console.error(`Error while payment success request ${error}`);
        throw error;
    }
};

export const paymentFailed = async (payload) => {
    try {
        return await api(method.POST, `/checkout/fail`, payload);
    } catch (error) {
        console.error(`Error while payment failed request ${error}`);
        throw error;
    }
};
